export const locations = [
  {
    name: 'Location Name One',
    eventType: 'Printed Digital, Rep Needed Onsite',
    eventDate: '2020-01-20',
    needByDate: '2019-11-07',
    packets: true,
    spanish: true,
    raffle: true,
    eligible: true,
    eligibleEmployees: 300,
    contactInformation: {
      name: 'David Smith',
      email: 'david@email.com',
      phone: 5555551234,
      phoneExt: 123
    },
    location: {
      address: '123 Milky Way Suite ABC',
      city: 'West Lake',
      state: 'KS',
      zipCode: 85214
    },
    requesterName: 'Billie Joe Armstrong',
    printedBenefits: true,
    digitalBenefits: true,
    startTime: '08:00',
    endTime: '09:00',
    spanishTranslation: true,
    multilingual: true,
    notes: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas leo ante, sagittis eu sagittis nec,' +
      ' facilisis eget ligula. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos'
  },
  {
    name: 'Location Name Two',
    eventType: 'Printed Digital',
    eventDate: '2020-01-21',
    needByDate: '2019-11-07',
    packets: true,
    spanish: true,
    raffle: true,
    eligible: true,
    eligibleEmployees: 60,
    location: {
      address: '456 Milky Way Suite ABC',
      city: 'West Lake',
      state: 'KS',
      zipCode: 85214
    },
    requesterName: 'Dave Grohl',
    printedBenefits: true,
    digitalBenefits: true,
    startTime: '08:00',
    endTime: '09:00',
    spanishTranslation: true,
    multilingual: true,
    notes: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas leo ante, sagittis eu sagittis nec,' +
      ' facilisis eget ligula. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos'
  },
  {
    name: 'Location Name Three',
    eventType: 'Printed Digital',
    eventDate: '2019-11-11',
    needByDate: '2019-11-07',
    packets: true,
    spanish: false,
    raffle: true,
    eligible: true,
    eligibleEmployees: 25,
    location: {
      address: '789 Milky Way Suite ABC',
      city: 'West Lake',
      state: 'KS',
      zipCode: 85214
    },
    requesterName: 'Paul McCartney',
    printedBenefits: true,
    digitalBenefits: true,
    startTime: '08:00',
    endTime: '09:00',
    spanishTranslation: true,
    multilingual: true,
    notes: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas leo ante, sagittis eu sagittis nec,' +
      ' facilisis eget ligula. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos'
  },
  {
    name: 'Location Name Four',
    eventType: 'Printed',
    eventDate: '2019-11-11',
    needByDate: '2019-11-07',
    packets: true,
    spanish: false,
    raffle: true,
    eligible: true,
    eligibleEmployees: 5,
    location: {
      address: '1011 Milky Way Suite ABC',
      city: 'West Lake',
      state: 'KS',
      zipCode: 85214
    },
    requesterName: 'Mark Hoppus',
    printedBenefits: true,
    digitalBenefits: true,
    startTime: '08:00',
    endTime: '09:00',
    spanishTranslation: true,
    multilingual: true,
    notes: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas leo ante, sagittis eu sagittis nec,' +
      ' facilisis eget ligula. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos'
  }
]
